import { Suspense, lazy } from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import ScrollToTop from "./components/ScrollToTop";
import WhatsAppButton from "./components/WhatsAppButton";
import Index from "./pages/Index";

// Lazy load non-critical pages for code splitting
const NotFound = lazy(() => import("./pages/NotFound"));
const Servicios = lazy(() => import("./pages/Servicios"));
const Videovigilancia = lazy(() => import("./pages/Videovigilancia"));
const ControlAcceso = lazy(() => import("./pages/ControlAcceso"));
const ControlAsistencia = lazy(() => import("./pages/ControlAsistencia"));
const Redes = lazy(() => import("./pages/Redes"));
const Contacto = lazy(() => import("./pages/Contacto"));
const SobreNosotros = lazy(() => import("./pages/SobreNosotros"));
const SoporteMantenimiento = lazy(() => import("./pages/SoporteMantenimiento"));
const TelefoniaIP = lazy(() => import("./pages/TelefoniaIP"));
const Alarmas = lazy(() => import("./pages/Alarmas"));

const queryClient = new QueryClient();

const App = () => (
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <ScrollToTop />
          <WhatsAppButton />
          <Suspense fallback={<div className="min-h-screen bg-background" />}>
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/servicios" element={<Servicios />} />
              <Route path="/videovigilancia-empresarial" element={<Videovigilancia />} />
              <Route path="/control-de-acceso-empresarial" element={<ControlAcceso />} />
              <Route path="/control-de-asistencia-para-empresas" element={<ControlAsistencia />} />
              <Route path="/redes-empresariales" element={<Redes />} />
              <Route path="/alarmas-para-empresas" element={<Alarmas />} />
              <Route path="/telefonia-empresarial" element={<TelefoniaIP />} />
              <Route path="/soporte-y-mantenimiento" element={<SoporteMantenimiento />} />
              <Route path="/contacto" element={<Contacto />} />
              <Route path="/sobre-nosotros" element={<SobreNosotros />} />
              {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </HelmetProvider>
);

export default App;
